export default __webpack_public_path__ + "static/person_3-78d1f57e762be06255b29adadaa23042.webp";